import { gql } from "@apollo/client";

export const ACTIVATE_SHOP = gql`
mutation ActivateShop($data: ActivateShopRequestDto!) {
  activateShop(data: $data)
}
`

export const CREATE_SHOP_COLLECTION = gql`
mutation CreateShopCollection($input: ShopCollectionInput) {
  createShopCollection(input: $input)
}
`

export const REMOVE_SHOP_COLLECTION = gql`
mutation RemoveShopCollection($removeShopCollectionId: ID!) {
  removeShopCollection(id: $removeShopCollectionId)
}`

export const UPDATE_SHOP_COLLECTION = gql`
mutation UpdateShopCollection($input: ShopCollectionInput) {
  updateShopCollection(input: $input)
}`

export const ADD_PRODUCT_TO_SHOP_COLLECTION = gql`
mutation AddProductToShopCollection($productId: ID!, $collectionId: ID!) {
  addProductToShopCollection(product_id: $productId, collection_id: $collectionId)
}`

export const ADD_PRODUCTS_TO_COLLECTION = gql`
mutation AddProductsToShopCollection($collectionId: ID!, $productIds: [ID!]) {
  addProductsToShopCollection(collection_id: $collectionId, product_ids: $productIds)
}`

export const ADD_PRODUCT_TO_SHOP = gql`
mutation AddProductToShop($shopId: ID!, $productId: ID!, $profitAdded: Float!) {
  addProductToShop(shop_id: $shopId, product_id: $productId, profit_added: $profitAdded)
}`

export const REMOVE_PRODUCT_FROM_COLLECTION= gql`
mutation RemoveProductFromCollection($input: AddProductsToCollectionInput) {
  removeProductFromCollection(input: $input)
}
`

export const REMOVE_PRODUCT_FROM_SHOP = gql`
mutation RemoveProductFromShop($shopId: ID!, $productId: ID!) {
  removeProductFromShop(shop_id: $shopId, product_id: $productId)
}`